import { render, staticRenderFns } from "./EmployeeForm.vue?vue&type=template&id=39d6ff31&scoped=true"
import script from "./EmployeeForm.vue?vue&type=script&lang=js"
export * from "./EmployeeForm.vue?vue&type=script&lang=js"
import style0 from "./EmployeeForm.vue?vue&type=style&index=0&id=39d6ff31&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39d6ff31",
  null
  
)

export default component.exports